import { Component } from '@opten/compiler/metadata/component';
import { Collapse } from '@opten/collapse/initializer';
import getParentWithClass from '@opten/dom/get-parent-with-class';
import getOffset from '@opten/dom/get-offset';
import getCss from '@opten/dom/get-css';
import parseCssUnit from '@opten/number/parse-css-unit';
import { getStickyOffset } from '../utilities/scroll-helper';
import hasClass from '@opten/dom/has-class';
import scrollToElement from '@opten/scroll/scroll-to-element';
@Component({ className: 'js-tiles__tile__dropdown-collapse' })
export class TilesDropdownCollapseComponent {
	private parentElement: HTMLElement;
	private parentElementToggle: HTMLElement;
	private collapseElement: Collapse;
	constructor(private element: HTMLElement) {
		this.collapseElement = new Collapse(element, { transitionDuration: 10 });
		this.parentElement = getParentWithClass(this.element, 'js-tiles__tile__dropdown');
		if (this.parentElement) {
			this.parentElementToggle = getParentWithClass(this.element, 'js-tiles__tile__dropdown__toggle');
			this.resizeParentElement();
			window.addEventListener('resize', () => this.resizeParentElement());
			this.element.addEventListener('show.opten.collapse', () => {
				let offset = getStickyOffset() * -1;
				offset -= 150;
				offset = Math.round(offset);
				scrollToElement(this.parentElement, undefined, undefined, offset);
			});
			this.element.addEventListener('shown.opten.collapse', () => {
				document.addEventListener('click', e => this.handleDropdownBackdropClick(e));
			});
			this.element.addEventListener('hide.opten.collapse', () => {
				document.removeEventListener('click', e => this.handleDropdownBackdropClick(e));
			});
		}
	}

	private resizeParentElement() {
		if (this.parentElementToggle) {
			if (hasClass(this.parentElement, 'is--active') === false) {
				const height = this.parentElementToggle.getBoundingClientRect().height + 'px';
				this.parentElement.style.minHeight = height;
				this.parentElement.parentElement.style.minHeight = height;
			}
		}
	}

	private handleDropdownBackdropClick(event: Event) {
		const target = event.target || event.currentTarget;
		if (target) {
			const closestDropdown = (target as HTMLElement).closest('.js-tiles__tile__dropdown');
			if ((closestDropdown !== null && closestDropdown !== undefined && closestDropdown.isEqualNode(this.parentElement)) === false) {
				if ((closestDropdown !== null && closestDropdown !== undefined) === false) {
					this.collapseElement.hide();
				}
			}
		}
	}
}
